/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

//@ts-nocheck
import React, { useEffect, useState, lazy } from "react";
import "react-responsive-modal/styles.css";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { EventBusModule } from "@vlinder-web/event-bus-module-react";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { useSessionStorage } from "react-use-storage";
import { CONTACT } from './config/data';
import {useTheme} from '../../providers/theme';

import {Contact} from "./component/ContactForm";

export interface ContactFormModalVWProps {
    open?: boolean;
}

import "./modal.css";

export const CONTACT_FORM_MODAL_OPEN = "ContactFormModalVW:Open";
export const CONTACT_FORM_MODAL_CLOSE = "ContactFormModalVW:Close";
export const CONTACT_FORM_MODAL_ON_SUCCESS = "ContactFormModalVW:ModalClose";
export const CONTACT_FORM_SUCCESS = "ContactFormModalVW:LoginSuccess";

const log: any = LoggerModule.getInstance();

const MODAL_ITEMS = {
    open: false,
};

export const ContactFormModalVW = (props: ContactFormModalVWProps) => {
    const eb = EventBusModule.getInstance().getEventBus();
    const [item, setItem] = useState(MODAL_ITEMS);
    const [value, setValue, removeValue] = useSessionStorage("authToken");
    // debugger;
    const theme = useTheme();

    useEffect(() => {
        _subscribe();
        return _unsubscribe;
    });

    const _subscribe = () => {
        eb.on(CONTACT_FORM_MODAL_OPEN, onModalOpen);
        eb.on(CONTACT_FORM_MODAL_ON_SUCCESS, closeModalOnSuccess);
        // eb.on(LOGIN_MODAL_CLOSE, onModalClose);
        // eb.on(LOGIN_SUCCESS, onLoginSuccess);
    };

    const _unsubscribe = () => {
        eb.off(CONTACT_FORM_MODAL_OPEN, onModalOpen);
        eb.off(CONTACT_FORM_MODAL_ON_SUCCESS, closeModalOnSuccess);
        // eb.off(LOGIN_MODAL_CLOSE, onModalClose);
        // eb.off(LOGIN_SUCCESS, onLoginSuccess);
    };

    const onModalOpen = (props: any) => {
        console.log(`in openModal item:`, props);
        if (item.open === false) {
            setItem({
                open: true,
                ...{ ...(props || {}) },
            });
        }
    };

    const onModalClose = () => {
        eb.emit(CONTACT_FORM_MODAL_CLOSE, null, {});
        if (item.open) {
            setItem({
                ...MODAL_ITEMS,
                open: false,
            });
        }
    };

    const closeModalOnSuccess = () =>{
        if (item.open) {
            setItem({
                ...MODAL_ITEMS,
                open: false,
            });
        }
    }

    const onLoginSuccess = (res) => {
        log.info("user Login Success", res);
        setValue("123456789");
        if (res?.authToken) {
            setValue("123456789");
        }
        eb.emit(LOGIN_SUCCESS, null, {
            loginUser: res,
        });
        if (item.open) {
            setItem({
                ...MODAL_ITEMS,
                open: false,
            });
        }
    };

    const _getModal = () => {
        if (item?.open) {
            return (
                <Modal
                    isOpen={item?.open}
                    toggle={onModalClose}
                    fullwidth={true}
                    size={"lg"}
                    centered={true}
                    animation={false}
                    fade={false}
                    style={{ width: "100%" }}
                >
                    <ModalHeader toggle={onModalClose} />
                    <ModalBody style={{ maxHeight: 500, overflow: "auto" }}>
                        <Contact
                            title={CONTACT?.title}
                            subject={CONTACT?.subject}
                            appId={CONTACT?.appId}
                            action={CONTACT?.action}
                            id={CONTACT?.id}
                            url={CONTACT?.url}
                            color={theme?.colors?.primary}
                            secondaryColor={theme?.colors?.white}
                            onFocusColor={theme?.colors?.black}
                        />
                    </ModalBody>
                </Modal>
            );
        }
        // else return null;
    };

    return <>{_getModal()} </>;
};
